/**
 * Created by robert.lavoie on 9/27/17.
 */
// https://github.com/patrickmichalina/fusebox-angular-universal-starter/blob/master/src/client/app/shared/services/server-response.service.ts

import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Inject, Injectable, Optional } from '@angular/core';
import { Response } from 'express';

export interface IServerResponseService {
  getHeader(key: string): string | number | string[];
  setHeader(key: string, value: string): this;
  setHeaders(dictionary: { [key: string]: string }): this;
  appendHeader(key: string, value: string, delimiter?: string): this;
  setStatus(code: number, message?: string): this;
  setNotFound(message?: string): this;
  setError(message?: string): this;
}

@Injectable()
export class ServerResponseService implements IServerResponseService {

  private response: Response;

  constructor(@Optional() @Inject(RESPONSE) res: any) {
    this.response = res;
  }

  /**
   * Gets the response header
   *
   * @param { String }
   *
   * @return { String }
   */
  getHeader(key: string): string {
    return this.response.getHeader(key) as string;
  }


  /**
   * Sets the response header
   *
   * @param { String }
   * @param { String }
   *
   * @return { ServerResponseService }
   */
  setHeader(key: string, value: string): this {
    if (this.response)
      this.response.header(key, value);
    return this;
  }


  /**
   * Appends the header to the response
   *
   * @param { String }
   * @param { String }
   * @param { String } defaults to ','
   *
   * @return { ServerResponseService }
   */
  appendHeader(key: string, value: string, delimiter = ','): this {
    if (this.response) {
      const current = this.getHeader(key);
      if (!current) return this.setHeader(key, value);

      const newValue = [...current.split(delimiter), value]
      .filter((el, i, a) => i === a.indexOf(el))
      .join(delimiter);

      this.response.header(key, newValue);
    }
    return this;
  }


  /**
   * Sets the response headers
   *
   * @param { Object }
   *
   * @return { ServerResponseService }
   */
  setHeaders(dictionary: { [key: string]: string }): this {
    if (this.response)
      Object.keys(dictionary).forEach(key => this.setHeader(key, dictionary[key]));
    return this;
  }


  /**
   * Sets the status code and status message
   *
   * @param { String }
   * @param { String } - Optional
   *
   * @return { ServerResponseService }
   */
  setStatus(code: number, message?: string): this {
    if (this.response) {
      this.response.statusCode = code;
      if (message)
        this.response.statusMessage = message;
    }
    return this;
  }


  /**
   * Sets the not found message and status code
   *
   * @param { String } defaults to not found
   *
   * @return { ServerResponseService }
   */
  setNotFound(message: string = 'not found'): this {
    if (this.response) {
      this.response.statusCode = 404;
      this.response.statusMessage = message;
    }
    return this;
  }


  /**
   * Sets the 500 error message and status code
   *
   * @param { String } defaults to internal server error
   *
   * @return { ServerResponseService }
   */
  setError(message: string = 'internal server error'): this {
    if (this.response) {
      this.response.statusCode = 500;
      this.response.statusMessage = message;
    }
    return this;
  }
}